import type { Product } from '../../../data/product';
import { Tooltip } from '../../popover/tooltip';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Reorder: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Reorder',
  minWidth: 75,
  accessorFn: (product) => {
    if (product.disabled) {
      return 'DISABLED';
    }

    if (product.auto_disabled) {
      return 'AUTO_DSBL';
    }

    if (product.min_qoh && product.min_qoh > 0) {
      return 'MIN_QOH';
    }

    return '';
  },
  cell: ({ item: product, value }) => {
    if (product.disabled) {
      return (
        <Tooltip content="You disabled this product. It won't appear in reorder suggestions.">
          <span className="has-tooltip">{value}</span>
        </Tooltip>
      );
    }

    if (product.auto_disabled) {
      return (
        <Tooltip content="Orderbot stopped suggesting this for reorder because it hasn't been selling. Suggestions resume automatically once sales pick up.">
          <span className="has-tooltip">{value}</span>
        </Tooltip>
      );
    }

    if (product.min_qoh && product.min_qoh > 0) {
      const tooltipText =
        product.case_qty && product.case_qty > 0 && product.min_qoh > product.case_qty
          ? `${product.min_qoh / product.case_qty} case(s)`
          : `${product.min_qoh} unit(s)`;

      return (
        <Tooltip content={tooltipText}>
          <span className="has-tooltip">{value}</span>
        </Tooltip>
      );
    }

    return <span>{value}</span>;
  },
  gloss: 'Whether Orderbot is suggesting this for reorder. If not, hover the cell to see why.',
});
